export default __webpack_public_path__ + "media/images/start-d443e819b6248a54c6eb466c75938306.png";